import { Brand } from '@sgm-frontend/core';
import { LangCode } from '../common/api-response.model';
import { Pager } from '../common/pagination.model';

export interface CategoriesResponse extends Pager {
  categories: CategoryInfoResponse[];
}
export interface AllCategoriesResponse extends Pager {
  records: CategoryResponse[];
}
export interface BrandCategoriesResponse extends Pager {
  categories: CategoryResponse[];
}

export interface CategoriesCarouselResponse extends Pager {
  categoriesSections: CategoryInfoResponse[];
}

export interface OneCategoryResponse {
  category: CategoryInfoResponse;
}

export interface CategoryInfoResponse {
  id: number;
  parentId?: number;
  img: string;
  date: Date;
  translations: CategoryTranslationInfo[];

  // Extendable Fields
  parent_id?: number;

  // Added for carousel
  priority?: number;
  show_in_carousel?: boolean;
}
export interface CategoryResponse {
  id: number;
  parentId?: number;
  img: string;
  date: Date;
  translation: CategoryTranslation;
  gradient_color_1?: string;
  gradient_color_2?: string;
  use_gradient_colors?: boolean;
  show_in_home?: boolean;
  cached_product_count: number;
category_translations?: CategoryTranslation[];
level?: string;
  // Extendable Fields
  parent_id?: number;
  slug: string;
  icon_image_url: string;
  name?: string;

  // Added for carousel
  priority?: number;
  show_in_carousel?: boolean;
}
export interface CategoryTranslation {
  __key: string;
  category_id: string;
  language: string;
  name: string;
  section_banner_url?: string;
  default_specifications_json?: string;
  sub_banner_url?: string;
  sub_home_page_url?: string;
  sub_home_page_mobile_url?: string;
  nav_image_url?: string;
  seo_title?: string;
  seo_slug?: string;
  seo_keywords?: string;
  seo_description?: string;
  page_content?: string;
  sub_banner_mobile_url?: string;
}

export interface HomeFooterCategoryResponse {
  categories: HomeFooterCategory[];
}

export interface HomeFooterCategory {
  parentCategory: CategoryResponse;
  subCategories: CategoryResponse[];
}

export interface CategoryTranslationInfo {
  langCode: LangCode;
  cateName: string;

  // Extendable fields
  id?: number;
  language?: LangCode;
  name?: string;
  specification?: any;
  date?: Date;

  // Added for carousel
  categoryName?: string;
  mainImg?: string;
}

export interface SubCategoryInfo {
  id: number;
  translations: {
    langCode: LangCode;
    categoryName: string;
  }[];
}

// Categories Sub Section

export interface CategoriesSectionSubResponse extends Pager {
  categoriesSections: CategoriesSectionInfo[];
}

export interface CategoriesSectionInfo {
  sectionStyle: SectionCategoryStyleResponse;
  subCategories: SectionSubCategory[];
}

export interface SectionCategoryStyleResponse {
  id: number;
  gradientColor1?: string;
  gradientColor2?: string;
  translations: SectionCategoryStyleTranslation[];
}

export interface SectionSubCategory {
  id: number;
  parentId?: number;
  translations: SectionSubCategoryTranslation[];
}

export interface SectionSubCategoryTranslation {
  langCode: LangCode;
  categoryName: string;
  subCategoryImg: string;
}

export interface SectionCategoryStyleTranslation {
  langCode: LangCode;
  categoryName: string;
}

export interface CategoryTreeTranslation {
  __key: string;
  language: string;
  name: string;
}

export interface CategoryTree {
  id: string;
  parent_category_id: string | null;
  slug: string;
  sort_order: number;
  show_in_home: boolean;
  icon_image_url: string;
  level?: string; // 'department' | 'category' | 'subcategory'
  cached_product_count?: number;
  translation: CategoryTranslation;
  children?: CategoryTree[]; // Recursive for subcategories
  category_brand_m2ms: CategoryBrandM2M[] | [];
}

export interface SpecificationApiResponse {
  allowed_specifications: Record<LangCode, string[]>;
  specification_sources: {
    department_specs: Record<LangCode, string[]>;
    category_specs: Record<LangCode, string[]>;
    subcategory_specs: Record<LangCode, string[]>;
  };
}
export interface CategoryBrandM2M {
  category_id: string;
  brand_id: string;
  sort_order: number;
  brand: Brand;
}
